import React from "react";

import {
  NotForMissionOperatorGuard,
  OnlyForAdminGuard,
} from "./NavigationGuards";
import { RealTimeMapPage } from "Pages/RealTimeMap/RealTimeMap.page";
import { MissionOperatorPage } from "Pages/MissionOperator/MissionOperator.page";
import { MissionPlannerPage } from "Pages/MissionPlanner/MissionPlanner.page";
import { WelcomePage } from "Pages/Welcome/Welcome.page";
import { VehiclesListPage } from "Pages/VehiclesList/VehiclesList.page";
import { VehicleTypesListPage } from "Pages/VehicleTypesList/VehicleTypesList.page";
import { FleetsListPage } from "Pages/FleetsList/FleetsList.page";
import { UsersListPage } from "Pages/UsersList/UsersList.page";
import { IntersectionsPage } from "Pages/Intersections/Intersections.page";
import { StationsPage } from "Pages/Stations/Stations.page";

export const AuthorizedRouter = [
  {
    path: "",
    element: (
      <NotForMissionOperatorGuard>
        <RealTimeMapPage />
      </NotForMissionOperatorGuard>
    ),
  },
  {
    path: "/operator",
    element: <MissionOperatorPage />,
  },
  {
    path: "/station",
    element: <StationsPage />,
  },
  {
    path: "/intersections",
    element: <IntersectionsPage />,
  },
  {
    path: "/missions",
    element: <MissionPlannerPage />,
  },
  {
    path: "/welcome",
    element: <WelcomePage />,
  },
  {
    path: "/vehicles",
    element: (
      <OnlyForAdminGuard>
        <VehiclesListPage />
      </OnlyForAdminGuard>
    ),
  },
  {
    path: "/vehicletypes",
    element: (
      <OnlyForAdminGuard>
        <VehicleTypesListPage />
      </OnlyForAdminGuard>
    ),
  },
  {
    path: "/fleets",
    element: (
      <OnlyForAdminGuard>
        <FleetsListPage />
      </OnlyForAdminGuard>
    ),
  },
  {
    path: "/people",
    element: (
      <OnlyForAdminGuard>
        <UsersListPage />
      </OnlyForAdminGuard>
    ),
  },
];
